<template>
  <v-card>
    <v-layout>
      <v-app-bar title="ONEPLAN Админка"></v-app-bar>

      <Navigation />

      <v-main style="min-height: 100vh">
        <v-container fluid>
          <v-card>
            <v-card-title>Контентные страницы</v-card-title>
            <v-card-text>
              <ContentPageList />
            </v-card-text>
          </v-card>
        </v-container>
      </v-main>
    </v-layout>
  </v-card>
</template>
<script>
import Navigation from "@/components/Navigation";
import ContentPageList from "@/components/ContentPage/ContentPageList";
export default {
  components: {
    Navigation,
    ContentPageList,
  },
};
</script>
